module.exports = __webpack_public_path__ + "static/img/042.e6f20547.png";